export const actionAdmin = {
  table: {
    id: 'ID',
    message: '編集内容',
    name: '氏名',
    methodType: '活動',
    typeAction: '分類',
    oldData: '古いデータ',
    newData: '新しいデータ',
    createdAt: '時間',
    create: '作成する',
    update: '編集',
    delete: '削除',
    import: 'インポート',
    attendance: 'エラーチェック',
    employee: 'スタッフ',
    csvInsert: 'インポート（追加）',
    csvUpdate: 'インポート（上書き）',
  },
  pageHeader: {
    title: '改訂履歴',
  },
}
